import { FC, useState } from 'react';

import { useCurrentEntertainerQuery } from '@queries/EntertainerQueries';

import { useCurrentUserCity } from '@hooks/useCurrentUserLocation';

import { useNavigate, useRouter } from '@router/index';

import IconButton from '@components/buttons/IconButton';
import { FontAwesomeIcon } from '@components/icons/FontAwesomeIcon';
import Card from '@components/layout/Card/Card';
import { Popup } from '@components/layout/Popup/Popup';
import { Screen } from '@components/layout/Screen/Screen';
import { Skeleton } from '@components/layout/Skeleton/Skeleton';

import { DeleteAccountOverlay } from '@screens/SettingsScreen';

import { CreateEditEntertainerProfileForm } from './CreateEntertainerProfileScreen';

const EntertainerFormContent: FC<{ onSave: () => void }> = ({ onSave }) => {
  const { entertainer } = useCurrentEntertainerQuery();
  const { currentCity, cities } = useCurrentUserCity();

  return (
    <>
      {entertainer && currentCity ? (
        <CreateEditEntertainerProfileForm
          currentCity={currentCity}
          cities={cities}
          entertainer={entertainer}
          onSave={onSave}
        />
      ) : (
        <>
          <Skeleton height={240} />
          <Skeleton height={42} />
          <Skeleton height={42} />
          <Skeleton height={42} />
          <Skeleton height={42} />
          <Skeleton height={42} />
        </>
      )}
    </>
  );
};

export const EditEntertainerPopup: FC<{ isVisible: boolean; onClose: () => {} }> = ({
  isVisible,
  onClose,
}) => {
  return (
    <Popup isVisible={isVisible} onClose={onClose} height="full">
      <Popup.Content>{isVisible && <EntertainerFormContent onSave={onClose} />}</Popup.Content>
    </Popup>
  );
};

export const EditEntertainerProfileScreen: FC<{}> = () => {
  const { back } = useRouter();
  const [deleteAccountOverlayIsVisible, setDeleteAccountOverlayIsVisible] = useState(false);

  const handleSave = () => {
    back();
  };

  return (
    <Screen
      name="Edit Entertainer Profile Screen"
      hideToolbar
      headerProps={{
        back: { to: '/manage/entertainer' },
        title: 'Edit Profile',
        right: (
          <IconButton
            variant="flat"
            color="danger"
            onClick={() => setDeleteAccountOverlayIsVisible(true)}
          >
            <FontAwesomeIcon faStyle="far" name="trash-alt" />
          </IconButton>
        ),
      }}
    >
      <Screen.Content maxWidth={425}>
        <EntertainerFormContent onSave={handleSave} />
      </Screen.Content>
      <DeleteAccountOverlay
        isVisible={deleteAccountOverlayIsVisible}
        onClose={() => setDeleteAccountOverlayIsVisible(false)}
      />
    </Screen>
  );
};
